import { get, ref } from "firebase/database";
import { auth, database } from "../firebase";

export default async function userName() {
  try {
    const user = auth.currentUser;
    if (!user) {
      return false;
    }
    const userUID = user.uid;

    // Query the users database to get the username
    const userRef = ref(database, `users/${userUID}`);
    const userSnapshot = await get(userRef);
    if (!userSnapshot.exists()) {
      return false;
    }
    const userData = userSnapshot.val();
    const username = userData.username;
    return username;
  } catch (error) {
    return false;
  }
}
